import { Dispatch, SetStateAction } from 'react';

import { Box, Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';
import { useQuerySellersVtexHistorico } from 'pages/logistica/sellers-vetex/hooks';
import { SellerVtexHistorico } from 'pages/logistica/sellers-vetex/types';
import { brlDateTime } from 'util/format';

type SellerVtexHistoricoModalProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    idSeller: string;
};

const getRows = (data: SellerVtexHistorico[] = []) =>
    data.map((item) => ({
        id: item.idSellerHistorico,
        dsUsuarioInclusao: item.dsUsuarioInclusao,
        dhInclusao: item.dhInclusao ? brlDateTime(`${item.dhInclusao}Z`) : '',
        dsAcao: item.dsValor === 'true' ? 'Ativou' : 'Desativou',
        dsObservacao: item.dsObservacao,
    }));

const columns: GridColDef[] = [
    { field: 'dsUsuarioInclusao', headerName: 'Usuário', flex: 1, minWidth: 220 },
    { field: 'dhInclusao', headerName: 'Data', minWidth: 130 },
    { field: 'dsAcao', headerName: 'Ação', minWidth: 80, sortable: false },
    { field: 'dsObservacao', headerName: 'Motivo', flex: 2, minWidth: 190, sortable: false },
];

export function SellersVtexHistoricoModal({ open, setOpen, idSeller }: SellerVtexHistoricoModalProps) {
    const { data, isFetching, refetch } = useQuerySellersVtexHistorico(idSeller);

    return (
        <ContentModal open={open} setOpen={setOpen} sx={{ borderRadius: 1, minWidth: { md: 760 } }} closeButton>
            <SubTitle label="Histórico de alterações" />

            <Box sx={{ height: 360 }}>
                <PanelGrid
                    autoHeight={false}
                    rows={getRows(data?.data)}
                    rowsCount={data?.total ?? 0}
                    columns={columns}
                    loading={isFetching}
                    reload={refetch}
                    customMessageNoRows="Nenhuma alteração disponível"
                />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button variant="outlined" onClick={() => setOpen(false)}>
                    Fechar
                </Button>
            </Box>
        </ContentModal>
    );
}
